import { Link } from "react-router-dom";
import { Phone, MessageCircle, ArrowRight } from "lucide-react";
import { CONTACT } from "../../data/site";

export const FloatingActions = () => {
  return (
    <>
      {/* Floating WhatsApp + Call (desktop + mobile) */}
      <div className="fixed bottom-24 right-4 z-40 flex flex-col gap-3 md:bottom-8 md:right-6">
        <a
          href={`https://wa.me/${CONTACT.whatsapp}?text=Hi%20CARDED%2C%20I%20would%20like%20to%20enquire%20about%20a%20loan.`}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat on WhatsApp"
          className="flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-black/10 transition-transform hover:scale-110"
          data-testid="floating-whatsapp"
        >
          <MessageCircle className="h-6 w-6" />
        </a>
        <a
          href={`tel:${CONTACT.phone}`}
          aria-label="Call CARDED"
          className="flex h-14 w-14 items-center justify-center rounded-full brand-gradient text-white shadow-lg shadow-[#6C2BD9]/30 transition-transform hover:scale-110"
          data-testid="floating-call"
        >
          <Phone className="h-6 w-6" />
        </a>
      </div>

      {/* Sticky Apply Now on mobile */}
      <div
        className="fixed bottom-0 left-0 z-50 w-full border-t border-[#E4E4E7] bg-white/90 p-3 backdrop-blur-xl md:hidden"
        data-testid="mobile-sticky-apply"
      >
        <Link
          to="/contact"
          className="flex w-full items-center justify-center gap-2 rounded-full brand-gradient py-3.5 font-medium text-white"
          data-testid="mobile-sticky-apply-btn"
        >
          Apply Now <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </>
  );
};

export default FloatingActions;
